import { Box } from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { fakeTableList, schema } from "./parts";
import { httpAPI_ACC007, httpAPI_ACC008 } from "./api/request";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRC010003 パスワード変更
 * @returns JSX.Element
 */
const SCRC010003 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  const fakeTableLists = useRef(_.cloneDeep(fakeTableList));
  const [disabled, setDisabled] = useState(false);
  // URLパラメータを取得
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token: any = queryParams.get("token");

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  // パスワード再発行トークン認証API実行
  const callApi = async () => {
    try {
      const res = await httpAPI_ACC007({ token });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        sessionStorage.setItem(
          "token",
          JSON.stringify({
            accessToken: res.token,
            refreshToken: res.refreshToken,
          })
        );
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        let resArr = fakeTableLists.current;
        resArr.forEach((item) => {
          item.disabled = true;
        });
        setStateFakeTableList([...resArr]);
        setDisabled(true);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (token) {
      callApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = fakeTableLists.current;
    let showPassword = resArr.find((item) => item.keyword === "showPassword");
    showPassword!.node = (
      <TkCheckbox
        label={showPassword!.title}
        onChange={handleCheck}
        disabled={disabled}
      />
    );
    setStateFakeTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    let resArr = fakeTableLists.current;
    let password = resArr.filter((item) => item.keyword !== "showPassword");
    password.length > 0 &&
      password.map((item: any) => {
        item.typeForLabelText = e?.target?.checked ? "text" : "password";
        return item;
      });
    setStateFakeTableList([...resArr]);
  };

  const handleSubmit = async (data: any) => {
    try {
      const res = await httpAPI_ACC008({
        password: data.password,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC010001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC010003" data-testid="SCRC010003PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC010003_01}</TkInfoManual>
      <Box>
        <TkFakeTable
          list={stateFakeTableList}
          ruleSchema={schema}
          onCheckAndSubmit={handleSubmit}
          submitButtonGroup={[
            {
              submitButtonText: "パスワード変更",
              submitButtonDisabled: disabled,
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default SCRC010003;
